import { GetClickAnalyticsList } from "../ApiEndPoints";
import { axiosPost } from "../AxiosRequests";

export default class ClickAnalyticsServices {
    async getClickAnalyticsList(request) {
        return axiosPost(GetClickAnalyticsList, request);
    }
}